export function PanelResizeHandle({ onResize, currentWidth }: { onResize: (w: number) => void; currentWidth: number }) {
  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = currentWidth;

    const handleMove = (moveEvent: MouseEvent) => {
      const dx = startX - moveEvent.clientX;
      onResize(Math.max(200, Math.min(500, startWidth + dx)));
    };
    const handleUp = () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseup', handleUp);
    };
    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleUp);
  };

  return (
    <div
      onMouseDown={handleMouseDown}
      style={{
        width: 4,
        background: '#e2e8f0',
        cursor: 'ew-resize',
        flexShrink: 0,
      }}
    />
  );
}
